import React from "react";
import Text from "@/bit/components/components.text";
import CImage from "@/bit/components/components.c-image";
import IconGlyph from "@/bit/components/components.icon-glyph";
import Video from "@/bit/components/components.cms-block.cms-video";
import PropTypes from "prop-types";

/**
 * Componente que permite crear un banner
 */
const Banner = (props) => {
  const {
    "cms-atom-text-1": title,
    "cms-atom-image-1": image,
    "cms-atom-video-1": videoProps,
    cmsHandler,
  } = props;

  let cssClassName = "screen-gap";

  return (
    <div className="banner-product">
      {cmsHandler && (
        <span
          className={"element-editable block edit-component"}
          onClick={() =>
            cmsHandler({
              ...props,
              name: "cms-block.cms-banner",
            })
          }
        >
          <IconGlyph id="lapiz-m" height={20} color="white" />
        </span>
      )}
      {title && (
        <div className="title-banner">
          <Text {...title} cmsHandler={cmsHandler} />
        </div>
      )}

      <div className={cssClassName} aria-hidden="true">
        {(cmsHandler || !videoProps || !videoProps.source) && (
          <CImage
            className="banner-image"
            {...image}
            fill
            cmsHandler={cmsHandler}
          />
        )}
        {(cmsHandler || (videoProps && videoProps.source)) && (
          <Video
            className="banner-video"
            {...videoProps}
            cmsHandler={cmsHandler}
          />
        )}
      </div>
      <style jsx>{`.banner-product {
  position: relative;  
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #ffffff;
  width: 100%;
  .screen-gap{
    position:relative;
    padding-top:75%;
    aspect-ratio: 4/3;
    overflow:hidden;
    border-radius: 16px;
    :global(video){
      position:absolute;
      top:0;      
    }
  }

  @media screen and (min-width: 1024px) {
    min-height: 500px;
    .screen-gap{
      border-radius:  25px;
    }
  }

  @media screen and (max-width: 768px) {
    .screen-gap {
      &.mobile-hide { display:none }
    }
  } 
}`}</style>
    </div>
  );
};

Banner.propTypes = {
  /**
   * {
   *  "info": "Determina si se oculta en mobile el banner",
   *  "kind": "both",
   *  "beautifulName": "Banner oculto en mobile"
   * }
   */
  mobileHide: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Banner.defaultProps = {
  mobileHide: false,
};

export default Banner;
